import './footer.css';

export default function Footer() {
    return (
        <div className='footer-container'>
            <a href='https://github.com/Ameer-Alaswad'>
                <img src='/icons/github-sign.svg' alt='' />
            </a>
            <a href='https://www.linkedin.com/in/ameer-alaswad-27219a207/'>
                <img src='/icons/linkedin.svg' alt='' />
            </a>
        </div>
    );
}
